import { getAvatarInitials } from './get-avatar-initials';

export function getAvatarColor(
  firstName?: string,
  lastName?: string,
  email?: string,
): string {
  const avatarInitials = getAvatarInitials(firstName, lastName, email);

  const colors: string[] = [
    '#776cb8',
    '#3e89e4',
    '#39b689',
    '#d53c77',
    '#e74b4b',
    '#798e9c',
    '#eda630',
  ];

  let sumChar = 0;
  let indexChar = 0;
  while (indexChar < avatarInitials.length) {
    sumChar += avatarInitials.charCodeAt(indexChar);
    indexChar++;
  }
  return colors[sumChar % colors.length];
}
